import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";
import { NewWorkOrder, NewWorkorderWithMetadata } from "../../shared/interfaces/WorkOrder";

export function useWorkorderCreation<T extends NewWorkorderWithMetadata | Partial<NewWorkOrder>>(
  options?: UseMutationOptions<number, Response, T>,
) {
  const apiContext = useContext(ApiContext);
  const queryClient = useQueryClient();
  return useMutation<number, Response, T>(
    ["workorderCreation"],
    async (workorder: T) => {
      if (isNewWorkorderWithMetadata(workorder))
        return apiContext.workOrderApis.createWorkorder(workorder.newWorkorder);
      else return apiContext.workOrderApis.createWorkorder(workorder as Partial<NewWorkOrder>);
    },
    {
      onSuccess: (data, variables, context) => {
        options?.onSuccess?.(data, variables, context);
        queryClient.invalidateQueries({
          queryKey: ["workordersWithAssignments"],
        });
      },
      onError: options?.onError,
    },
  );
}

export function isNewWorkorderWithMetadata(
  workorder: NewWorkorderWithMetadata | Partial<NewWorkOrder>,
): workorder is NewWorkorderWithMetadata {
  return "newWorkorder" in workorder;
}
